import React, { useState, useEffect } from 'react';
import moment from "moment";
import DatePicker from "react-datepicker";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import FCSelectSiteField from "../../../utils/library/selectsitefield";
import { getUserData } from '../../../utils/common/functions';
import siteApi from '../../../utils/api/siteApi';
import clientsApi from '../../../utils/api/clientsApi';
import { adminDashboardApi } from '../../../utils/api/adminDashboardApi';
import { FilterIcon } from "../../../utils/common/icon-hooks";
import  MultiFilter  from "../../landing/multifilter";

NoDataToDisplay(Highcharts);


const dashboardvalues = {
	totalSites: 0,
	totalSamplePlans: 0,
	totalTestPoints: 0,
	totalTests: 0,
	passedTests: 0,
	failedTests: 0,
	totalTestsLifetime: 0,
	totalTestsYearToDate: 0,
	monthlyTestSummaries : []
}
const AdminDashboard = () => {

	const initialChartOptions = {
		chart: {
			type: "column",
			height: 300,
		},
		title: {
			text: "Total tests completed by month",
			align: "center",
			style: { fontSize: "16px", fontWeight: "bold", },
		},
		xAxis: {
			categories: [],
			title: { text: null },
		},
		yAxis: {
			min: 0,
			title: {text: null},
			enabled: false,
			labels: { overflow: "justify" },
		},
		tooltip: {
			valueSuffix: " tests",
		},
		plotOptions: {
			column: {
				dataLabels: { enabled: true },
				showInLegend: false 
			},
		},
		lang: {
			noData: "No data to display"
		},
		legend: {enabled : false},
		credits: { enabled: false },
		series: [
			{
				name: "",
				data: [], 
				color: "#3490dc",
			},
		],
	};

	const [userData, setUserData] = useState(null);
	const [dateRange, setDateRange] = useState([moment().subtract(8, "days").startOf("day").toDate(), moment().subtract(1, "days").endOf("day").toDate()]);
	const [startDate, endDate] = dateRange;
	const [companyOptions, setCompanyOptions] = useState([]);
	const [siteOptions, setSiteOptions] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [dashboard, setDashboard] = useState(dashboardvalues)
	const [chartOptions, setChartOptions] = useState(initialChartOptions);
	const [error, setError] = useState(false);
	const [selectedSites, setSelectedSites] = useState([]);
	const [siteMultiFilter, setSiteMultiFilter] = useState(false);
	const [selectedSiteIds, setSelectedSiteIds] = useState([]);
	const [siteList, setSiteList] = useState([]);
	const [siteCount, setSiteCount] = useState(0);

	const currentYear = new Date().getFullYear();
	const maxDate = new Date(currentYear, 11, 31);
	const minDate = new Date(1990, 0, 1);


	const getAllClients = async () => {
		const response = await clientsApi.getClients()
		if (response.status >= 200 && response.status <= 299) {
			let options = [];
			response.data.map((item) => {
				options.push({ label: item.name, value: item.id })
			});
			setCompanyOptions(options);
			setError(false);
		} else {
			setError(response.statusText)
		}
		return response
	}


	const getAllSites = async (user,clientId) => {
		const response = await siteApi.getAllSites({
			userId: user.id,
			userToken: user.userToken,
			clientId : clientId
		})
		if (response.status >= 200 && response.status <= 299) {
			let options = [];
			response.data.map((item) => {
				options.push({ label: item.name, value: item.id.toString() })
			});
			setSiteCount(options.length)
			setSiteList(options)
			setSiteOptions(options);
			setError(false);
		} else {
			setError(response.statusText)
		}
		return response
	}
	const getAdminDashBoardData = async (user) => {
		const response = await adminDashboardApi.getAdminDashboardData(user)
		if (response.status >= 200 && response.status <= 299) {
			const months =  response?.data && response?.data?.monthlyTestSummaries.map(item =>
				item.monthYear
			);
			const counts = response?.data && response?.data?.monthlyTestSummaries.map(item => item.count);
			const updatedChartOptions = {
				...chartOptions,
				xAxis: { ...chartOptions.xAxis, categories: months },
				series: [{ ...chartOptions.series[0], data: counts }],
			};
			setChartOptions(updatedChartOptions)
			setDashboard(response.data);
		} else {
			setError(response.statusText)
		}
		return response
	}
	const onClientChange = (event) => {
		if (event.value === null) {
			return;
		}
		if (companyOptions) {
			getAllSites(userData, event.value)
			setSelectedSites([]);
			setSelectedSiteIds([]);
			setDashboard(dashboardvalues)
			setChartOptions(initialChartOptions)
			setSelectedCompany(companyOptions.find((o) => o.value === event.value));
		}
	};
	const handleMultiFilter = (event, type) => {
		if (!event?.target) return;
		const { checked, value } = event.target;
		if (type === "site") {
			setSelectedSiteIds(prev => checked
				? [...prev, value]
				: prev.filter(val => val !== value)
			);
		}
	}
	const handleSearchSite = (searchTxt, type) => {
		if (type == 'site') {
			if (siteList.length === 0) return;
			setSelectedSiteIds([]);

			const filteredItems = searchTxt === ""
				? siteList
				: siteList.filter(item =>
					item.label?.toLowerCase().includes(searchTxt.toLowerCase())
				);

			const options = filteredItems.map(item => ({
				label: item.label,
				value: item.value
			}));

			setSiteOptions(options);
		}
	}
	const multiFilterClose = () => {
		setSiteMultiFilter(false)
	}
	const handleSelectAll = (type) => {
		if (type === "site") {
			const allIds = siteOptions.map(site => site.value.toString());
			setSelectedSiteIds(allIds);
		}
	};
	const handleDeselectAll = (type) => {
		if (type === "site") {
			setSelectedSiteIds([]);
			setSelectedSites([]);
		}
	};
	const handleMultiFilterApply = (type) => {
		if (type == "site") {
			const matchedSites = selectedSiteIds
				.map(id => siteList.find(site => site.value === id))
				.filter(Boolean);

			setSelectedSites(matchedSites);
			setSiteMultiFilter(false)
		}
	}
	const onDateChange = (dates) => {
		const [start, end] = dates;

		setDateRange([
			start ? new Date(`${moment(start).format("LL")} 00:00:00`) : start,
			end ? new Date(`${moment(end).format("LL")} 23:59:59`) : end,
		]);
	};
	useEffect(() => {
		var user = getUserData();
		setUserData(user);
		getAllClients();
	}, [])
	useEffect(() => {
		if (selectedCompany != null && selectedSites &&selectedSites.length >0 && dateRange[0] && dateRange[1]) {
			let reqData = {
				siteId: selectedSiteIds,
				userId: userData?.id,
				userToken: userData?.userToken,
				clientId: selectedCompany?.value,
				dateFrom: moment(dateRange[0]).startOf("day").toISOString(),
				dateTo: moment(dateRange[1]).endOf("day").toISOString(),
			};
			getAdminDashBoardData(reqData);
		}

	}, [selectedCompany, selectedSites, dateRange])
	useEffect(() => {
		const hasData = chartOptions.series?.some(s => s.data && s.data.length > 0);

		setChartOptions((prev) => ({
			...prev,
			xAxis: {
				...prev.xAxis,
				labels: { ...prev.xAxis.labels, enabled: hasData },
				title: { ...prev.xAxis.title, enabled: hasData },
				lineWidth: hasData ? 1 : 0,
				tickWidth: hasData ? 1 : 0,
			},
			yAxis: {
				...prev.yAxis,
				labels: { ...prev.yAxis.labels, enabled: hasData },
				title: { ...prev.yAxis.title, enabled: hasData },
				gridLineWidth: hasData ? 1 : 0,
				lineWidth: hasData ? 1 : 0,
				tickWidth: hasData ? 1 : 0,
			},
			legend: {
				enabled: hasData,
			},
		}));
	}, [chartOptions.series]);
	return (
		<div className="py-4 px-10">
		<div className="w-full flex pb-3 border-b-2 border-gray-300">
			<div className="w-full flex">
					<div className="w-1/2 px-5">
					<div className="block pl-1 text-fclabel">Select Company</div>
					<FCSelectSiteField
							id="sites"
							onChange={(event) => { onClientChange(event) }}
							placeholder={'Select Company' }
							options={companyOptions}
							isDropdown={true}
							value={selectedCompany}
							className="w-full"
					/>
				</div>
				<div className="w-1/12"></div>
				<div className="w-1/2 px-5">
					<div className="block pl-1 text-fclabel">Select Site</div>
						<div className="flex items-center gap-2">
							<FCSelectSiteField
								id="plans"
								placeholder={'Select Site'}
								count={siteCount}
								options={siteOptions}
								value={selectedSites}
								isDropdown={false}
								className="w-full"
							/>
							<button onClick={() => setSiteMultiFilter(true)}>
								<FilterIcon />
							</button>
						</div>
					</div>
					<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
						<MultiFilter options={siteOptions} selectedIds={selectedSiteIds} isOpen={siteMultiFilter} multiFilterClose={multiFilterClose}
							handleSearchSite={handleSearchSite} handleMultiFilterApply={handleMultiFilterApply} handleMultiFilter={handleMultiFilter} type={"site"}
							handleFilterSelectAll={handleSelectAll} handleDeSelectAll={handleDeselectAll}
						/>
					</div>
				<div className="w-1/12"></div>
						<div className="w-1/2 px-5">
							<div className="block pl-1 text-fclabel">Select Date Range</div>
						<DatePicker
							dateFormat={"dd/MM/yyyy"}
							selectsRange={true}
							startDate={startDate}
							maxDate={maxDate}
							minDate={minDate}
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
							endDate={endDate}
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
							onChange={(value) => onDateChange(value)}
							onCalendarClose={() => { } }
							className="border-2 border-gray-300 p-2 rounded-2xl blueText w-full"
							/>
				</div>
			</div>
			</div>
			<div className="w-full flex p pt-3 pb-3 border-b-2 border-gray-300">
				<div className="w-full px-5 md:w-1/3 space-y-2 text-sm md:text-base">
					<div>Total Sites: {dashboard?.totalSites}</div>
					<div>Total Sample Plans: {dashboard?.totalSamplePlans}</div>
					<div>Total Test Points: {dashboard?.totalTestPoints}</div>
					<div>
						Total Tests: {" "}
						<span className="text-blue-600 font-semibold">{dashboard?.totalTests}</span>{" "}
						(<span className="text-blue-400">{dashboard?.passedTests}</span> /{" "}
						<span className="text-orange-500 ">{dashboard?.failedTests}</span>)
					</div>
					<div>Total Tests YTD: {dashboard?.totalTestsYearToDate}</div>
					<div>Total Tests Lifetime: {dashboard?.totalTestsLifetime}</div>
				</div>
				<div className="w-9/10 border-2 border-gray-300 rounded-2xl overflow-hidden">
					<HighchartsReact highcharts={Highcharts} constructorType={"chart"} options={chartOptions} />
				</div>
			</div>
			<div className="w-full flex p pt-3 pb-3">
				<div className="w-full px-5 md:w-1/3 space-y-2 text-sm md:text-base">
						<div className="flex">Total Spend : - </div>
					<div className="flex">Total Spend YTD  : - </div>
					<div className="flex">Total Spend Lifetime : - </div>
					<div className="flex mt-4">Last Purchase Date  : - </div>
					<div className="flex">Last Purchase Quantity : - </div>
					<div className="flex">Last Purchase Value    : - </div>
					</div>
					<div className="flex flex-col items-center justify-center w-full md:w-1/2 mt-6 md:mt-0 text-center">
						<div className="text-sm font-medium text-[#00194A]">Estimated Test Days Remaining</div>
						<div className="text-3xl font-bold text-[#00194A] mt-2"> - </div>
					<div className="text-sm text-gray-500 mt-1">
						More tests required by <span className="font-medium ml-5 text-gray-700"> - </span>
					</div>
					</div>
				</div>
		</div>
	)
}
export default AdminDashboard